import { DropListItemSpark, ResponseSparkData } from './types';

export const sparkDataToItemDropList = (
  item: ResponseSparkData,
): DropListItemSpark => {
  const option = item.name;

  const inn = item.inn;

  const address = item.address;

  const description = `ИНН: ${inn}, ${address}`;

  return {
    id: String(item.id),
    inn: item.inn,
    company: option,
    content: {
      option,
      description,
    },
  };
};
